<!--import wangEditor from '@/components/WangEditor'
<wangEditor v-model="form.txt" :is-clear="true" />-->
<template>
  <div class="editor">
    <div ref="toolbar" class="toolbar" />
    <div ref="editor" class="text" />
  </div>
</template>

<script>
import E from 'wangeditor'
import { baseUrl } from '@/utils/request'
// import { mapGetters } from 'vuex'

export default {
  name: 'WangEditor',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    isClear: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editor: null,
      info_: null,
      freshNum: 0,
      fileUploadOSSApi: baseUrl + 'common/upload'
    }
  },
  watch: {
    isClear (val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear()
        this.info_ = null
      }
    }
    // value: {
    //   handler:function(value) {
    //   // if(value){
    //   //   this.editor.txt.html(value)
    //   // }else{
    //   //   this.editor.txt.html('')
    //   // }
    //   //    console.log(value)
    //   //   console.log(this.editor.txt.html())
    //
    //
    //
    //   },
    //   immediate:true
    // },
  },
  mounted () {
    this.seteditor()
    //
    this.$watch('value', {
      handler: function (value) {
        if (value !== this.editor.txt.html()) {
          console.log('value !== this.editor.txt.html()')
          console.log(value)
          if (!value) {
            this.editor.txt.clear()
          } else {
            this.editor.txt.html(value)
          }
          this.info_ = value
        }
      },
      immediate: true
    })
  },
  updated () {
  },
  methods: {
    seteditor () {
      this.editor = new E(this.$refs.toolbar, this.$refs.editor)
      this.editor.config.uploadVideoServer = this.fileUploadOSSApi
      this.editor.config.uploadVideoName = 'file'
      this.editor.config.uploadVideoHooks = {
        // 上传视频之前
        before: function (xhr) {
          console.log(xhr)
        },
        // 视频上传并返回了结果，视频插入已成功
        success: function (xhr) {
          console.log('success', xhr)
        },
        // 视频上传并返回了结果，但视频插入时出错了
        fail: function (xhr, editor, resData) {
          console.log('fail', resData)
        },
        // 上传视频出错，一般为 http 请求的错误
        error: function (xhr, editor, resData) {
          console.log('error', xhr, resData)
        },
        // 上传视频超时
        timeout: function (xhr) {
          console.log('timeout')
        },
        // 视频上传并返回了结果，想要自己把视频插入到编辑器中
        // 例如服务器端返回的不是 { errno: 0, data: { url : '.....'} } 这种格式，可使用 customInsert
        customInsert: function (insertVideoFn, result) {
          // result 即服务端返回的接口
          // console.log('customInsert', result)
          // insertVideoFn 可把视频插入到编辑器，传入视频 src ，执行函数即可
          insertVideoFn(result.data.url)
        }
      }

      this.editor.config.placeholder = ''
      this.editor.config.focus = false
      this.editor.config.uploadImgServer = this.fileUploadOSSApi // 配置服务器端地址
      this.editor.config.uploadFileName = 'file' // 后端接受上传文件的参数名
      this.editor.config.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
      this.editor.config.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
      this.editor.config.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间

      this.editor.config.uploadImgHooks = {
        fail: (xhr, editor, result) => {},
        success: (xhr, editor, result) => {},
        timeout: (xhr, editor) => {},
        error: (xhr, editor) => {},
        customInsert: (insertImg, result, editor) => {
          const url = result.data.fullUrl
          insertImg(url)
        }
      }
      this.editor.config.onchange = (html) => {
        this.info_ = html // 绑定当前逐渐地值
        this.$emit('change', this.info_) // 将内容同步到父组件中
      }
      // 创建富文本编辑器
      this.editor.create()

      console.log(this.disabled)
      if (this.disabled === true) {
        // this.editor.disable()
      }
    }
  }
}
</script>

<style scoped>
  .editor {
    width: 1100px;
    /* margin: 0 auto; */
    position: relative;
    z-index: 0;
  }
  .toolbar {
    border: 1px solid #cccccc;
  }
  .text {
    border: 1px solid #cccccc;
    height: 500px;
    overflow-y: auto;
  }
</style>
